import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';

import { FormCard, FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { CreateBrandForm } from './CreateBrandForm';

export const CreateBrandPage: React.FC = () => {
  const { goToList } = useListReturn(ROUTES.BRANDS);

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Новий бренд</h2>
      </FormPageHeader>
      <FormCard>
        <CreateBrandForm />
      </FormCard>
    </FormPageContainer>
  );
};
